type NotificationListItem = {
    active: boolean;
    name: string;
    shownAt?: string;
    closedAt?: string;
};

const findActiveNotificationIndex = (allNotifications: NotificationListItem[], notificationName: string): number => {
    return allNotifications.findIndex((notification) => notification.name === notificationName && notification.active);
};

export const findActiveNotification = (
    allNotifications: NotificationListItem[],
    notificationName: string
): NotificationListItem | undefined => {
    const activeIndex = findActiveNotificationIndex(allNotifications, notificationName);

    if (activeIndex === -1) {
        return undefined;
    }

    return allNotifications[activeIndex];
};

export const buildUpdatedNotificationsOnShown = (
    allNotifications: NotificationListItem[],
    notificationName: string,
    shownAt: string
): NotificationListItem[] => {
    const activeIndex = findActiveNotificationIndex(allNotifications, notificationName);

    if (activeIndex === -1) {
        return allNotifications;
    }

    return allNotifications.map((notification, index) => {
        if (index !== activeIndex) {
            return notification;
        }

        return { ...notification, shownAt };
    });
};

export const buildUpdatedNotificationsOnConfirm = (
    allNotifications: NotificationListItem[],
    notificationName: string,
    closedAt: string
): NotificationListItem[] => {
    const activeIndex = findActiveNotificationIndex(allNotifications, notificationName);

    if (activeIndex === -1) {
        return allNotifications;
    }

    return allNotifications.map((notification, index) => {
        if (index !== activeIndex) {
            return notification;
        }

        return {
            ...notification,
            active: false,
            closedAt,
        };
    });
};
